
export default [
  {
    path: '/login',
    name: 'login',
    component: resolve => require.ensure([], () => resolve(require('@/views/login/index.vue')), 'login'),
    meta: { title: '登录页', icon: '' }
  }
]
